// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRODUCT_QP_PARAMS_FILE_UPLOAD_CHOOSE,
} from './constants';

export function qpParamsFileUploadChoose(visible,id) {
  return {
    type: PRODUCT_QP_PARAMS_FILE_UPLOAD_CHOOSE,
    data:{visible,id}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRODUCT_QP_PARAMS_FILE_UPLOAD_CHOOSE:
      return {
        ...state,
        qpParamsFileUploadingVisible: action.data.visible,
        qpParamsFileUploadingId: action.data.id
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/product/redux/qpParamsFileUploadChoose.js